/* eslint semi: 0 */

// patch for Samsung Internet Browser 7.2 issue
// see: https://github.com/SamsungInternet/support/issues/56
if (navigator.userAgent.match(/SamsungBrowser\/7\.[23]/i)) {
  Function.prototype.ToString = function ToString() {
    return this.toString()
  }
}
